import { render, staticRenderFns } from "./TherapySchoolQuestionnaire.vue?vue&type=template&id=7b0c6972"
import script from "./TherapySchoolQuestionnaire.vue?vue&type=script&lang=js"
export * from "./TherapySchoolQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./TherapySchoolQuestionnaire.vue?vue&type=style&index=0&id=7b0c6972&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports